module.exports = __webpack_public_path__ + "img/66500budui.d19ba516.jpg";